import Grid from "@mui/material/Grid2";

import { Button } from "@mui/material";

function Home() {
  return (
    <Grid
      container
      id="main"
      display="flex"
      justifyContent="center"
      alignItems="center"
      size="grow"
      spacing={2}
      columns={1}
      sx={{ width: "100%" }}
    >
      <Grid id="main-text" sx={{ width: "100%" }} item>
        William
      </Grid>
      <Grid item>
        <Grid container spacing={2} columns={5} display="flex" size="shrink">
          <Grid item>
            <Button
              onClick={() => {
                window
                  .open("https://github.com/RoddaWilliam", "_blank")
                  .focus();
              }}
              color="melancholygrey"
              variant="contained"
            >
              Github
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                window
                  .open(
                    "https://www.instagram.com/awesomewilliamrodda/",
                    "_blank"
                  )
                  .focus();
              }}
              color="melancholygrey"
              variant="contained"
            >
              Instagram
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                alert(
                  "No working dc link, add meh private (username: charities)"
                );
              }}
              color="melancholygrey"
              variant="contained"
            >
              Discord
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                window.location.href = "mailto:contact@williamrodda.xyz";
              }}
              color="melancholygrey"
              variant="contained"
            >
              Email
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={() => {
                window
                  .open(
                    "https://open.spotify.com/user/61ny1ja7tt69k96v32xauvuqd?si=29edbbe716374881",
                    "_blank"
                  )
                  .focus();
                alert("spotify may be cooked");
              }}
              color="melancholygrey"
              variant="contained"
            >
              Spotify
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Home;
